import { useState, useEffect } from "react";
import api from "@/api/client";
import { useAuth } from "@/context/AuthContext";

// Default Menü-Konfiguration - MUSS MIT ACTIONS aus CommandPalette.jsx übereinstimmen
const DEFAULT_CONFIG = [
  { id: "checkout", label: "Checkout", enabled: true, order: 0 },
  { id: "neue-bilder", label: "Neue Bilder ohne Exposé", enabled: true, order: 1 },
  { id: "data-check", label: "Data Check", enabled: true, order: 2 },
  { id: "benutzer", label: "Benutzer", enabled: true, order: 3 },
  { id: "audit-log", label: "Audit Log", enabled: true, order: 4 },
  { id: "auswertungen", label: "Auswertungen", enabled: true, order: 5 },
  { id: "wartungen", label: "Wartungen", enabled: true, order: 6 },
  { id: "ruecklieferungen", label: "Rücklieferungen", enabled: true, order: 7 },
  { id: "bauhof", label: "Bauhof Management", enabled: true, order: 8 },
  { id: "batch-bearbeitung", label: "Vermietung und Verkauf", enabled: true, order: 9 },
  { id: "reisen", label: "Reisekosten", enabled: true, order: 10 },
  { id: "media-verwaltung", label: "Media Verwaltung", enabled: true, order: 11 },
  { id: "kalkulation", label: "Kalkulation", enabled: true, order: 12 },
  { id: "lebenslauf", label: "Lebenslauf", enabled: true, order: 13 },
  { id: "einstellungen", label: "Einstellungen", enabled: true, order: 14 },
];

export function useMenuConfig() {
  const { user } = useAuth();
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);
  const [reloadToken, setReloadToken] = useState(0);

  // Nach Speichern in der Menü-Verwaltung ohne Seiten-Reload aktualisieren
  useEffect(() => {
    const handler = () => setReloadToken((v) => v + 1);
    window.addEventListener("menu-config-updated", handler);
    return () => window.removeEventListener("menu-config-updated", handler);
  }, []);

  useEffect(() => {
    if (!user) {
      setConfig(DEFAULT_CONFIG);
      setLoading(false);
      return;
    }

    // Lade Konfiguration für aktuellen Benutzer
    api.get(`/users/${user.id}/command-palette-config`)
      .then((res) => {
        const saved = res.data.config;
        if (!saved || saved.length === 0) {
          setConfig(DEFAULT_CONFIG);
          return;
        }
        // Neue Menüpunkte (noch nicht in gespeicherter Config) standardmäßig aktiv anhängen
        const savedIds = new Set(saved.map((item) => item.id));
        const missing = DEFAULT_CONFIG
          .filter((item) => !savedIds.has(item.id))
          .map((item, idx) => ({ ...item, order: saved.length + idx }));
        setConfig([...saved, ...missing]);
      })
      .catch((err) => {
        console.error("Fehler beim Laden der Menü-Konfiguration:", err);
        setConfig(DEFAULT_CONFIG);
      })
      .finally(() => setLoading(false));
  }, [user, reloadToken]);

  // Filtere nur aktivierte Menüpunkte und sortiere nach order
  const enabledActions = config
    .filter(item => item.enabled)
    .sort((a, b) => a.order - b.order);

  return { config, enabledActions, loading };
}
